import { CreateBenefitRequest, useToast } from '@aslanpay/portal-common-lib';
import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import { authenticatedPaths } from 'app/constants/routes';
import useAuthContext from 'app/hooks/useAuthContext';
import useBenefits from 'app/hooks/useBenefits';
import { useNavigate } from 'react-router-dom';
import AddEditBenefitForm, {
  AddEditBenefitFormFields,
} from 'app/components/Benefits/AddEditBenefitForm';

import buildBenefitPayload from './AddBenefit.function';

function AddBenefit() {
  const navigate = useNavigate();
  const { company } = useAuthContext();
  const toast = useToast();

  const { mutate: createBenefit, isPending: isSaving } = useBenefits.useCreateBenefit(company?.id);

  const handleBack = () => navigate(authenticatedPaths.benefitsManager.path);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const showApiErrors = (error: any, fallbackMessage: string) => {
    const subErrors = error?.response?.data?.subErrors;
    if (Array.isArray(subErrors) && subErrors.length > 0) {
      subErrors.forEach((subError: { message?: string }) => {
        if (subError.message) {
          toast({
            position: 'top-right',
            status: 'error',
            title: 'Error',
            description: subError.message,
          });
        }
      });
      return;
    }

    const errorMessage = error?.response?.data?.message;
    toast({
      position: 'top-right',
      status: 'error',
      title: 'Error',
      description: typeof errorMessage === 'string' ? errorMessage : fallbackMessage,
    });
  };

  const createDraftBenefit = (info: AddEditBenefitFormFields) => {
    createBenefit(buildBenefitPayload(info, 'DRAFT') as CreateBenefitRequest, {
      onSuccess: () => {
        toast({ position: 'top-right', status: 'success', title: 'Draft saved.' });
        navigate(authenticatedPaths.benefitsManager.path);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => showApiErrors(error, 'Failed to save draft.'),
    });
  };

  const handlePublish = (data: AddEditBenefitFormFields) => {
    createBenefit(buildBenefitPayload(data, 'PUBLISHED') as CreateBenefitRequest, {
      onSuccess: () => {
        toast({ position: 'top-right', status: 'success', title: 'Benefit published.' });
        navigate(authenticatedPaths.benefitsManager.path);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => showApiErrors(error, 'Failed to publish benefit.'),
    });
  };

  return (
    <AuthenticatedPageWrapper title="Add new benefit">
      <AddEditBenefitForm
        handleBack={handleBack}
        publishBenefit={handlePublish}
        saveDraftBenefit={createDraftBenefit}
        isSaving={isSaving}
      />
    </AuthenticatedPageWrapper>
  );
}

export default AddBenefit;
